export const adminTab = [
  {
    id: 1,
    name: "Admin Staff",
    value: "ACTIVE",
  },
  {
    id: 2,
    name: "Deactivated Admin Staff",
    value: "DEACTIVATED",
  },
];

export const managerTab = [
  {
    id: 1,
    name: "Active Manger",
    value: "ACTIVE",
  },
  {
    id: 2,
    name: "Deactivated Manager Staff",
    value: "DEACTIVATED",
  },
];

export const subcontractorTab = [
  {
    id: 1,
    name: "Active Subcontractor",
    value: "ACTIVE",
  },
  {
    id: 2,
    name: "Deactivated Subcontractor",
    value: "DEACTIVATED",
  },
  {
    id: 3,
    name: "Terminated Subcontractor",
    value: "TERMINATED",
  },
];

export const employeeTabs = [
  {
    id: 1,
    name: "Active",
    value: "ACTIVE",
  },
  {
    id: 2,
    name: "Awaiting",
    value: "AWAITING",
  },
  {
    id: 3,
    name: "Deactivated",
    value: "DEACTIVATED",
  },
  {
    id: 4,
    name: "Terminated",
    value: "TERMINATED",
  },
  {
    id: 5,
    name: "Employee Device",
    value: "DEVICE",
  },
  {
    id: 6,
    name: "Weighscale Device",
    value: "weighscale-device",
  },
];

export const CustomerTab = [
  {
    id: 1,
    name: "Customer",
    value: "CUSTOMER",
    status: "ACTIVE",
  },
  {
    id: 2,
    name: "Customer's User",
    value: "CUSTOMERUSER",
    status: "ACTIVE",
  },
  {
    id: 3,
    name: "Deactivated Customer",
    value: "DEACTIVATED_CUSTOMER",
    status: "DEACTIVATED",
  },
  {
    id: 4,
    name: "Deactivated Customer's User",
    value: "DEACTIVATED_CUSTOMERUSER",
    status: "DEACTIVATED",
  },
];

export const projectTab = [
  {
    id: 1,
    name: "Ongoing",
    value: "ONGOING",
  },
  {
    id: 2,
    name: "Completed",
    value: "COMPLETED",
  },
  {
    id: 3,
    name: "Archive",
    value: "ARCHIVE",
  },
];

export const ProspectTab = [
  {
    id: 1,
    name: "Prospect",
    value: "PROSPECT",
  },
  {
    id: 2,
    name: "Prospect's User",
    value: "PROSPECTUSER",
  },
];

export const timetrackingTab = [
  {
    id: 1,
    name: "Employee Shifts",
    value: "employee-shift",
  },
  {
    id: 2,
    name: "Sub Contractor Shifts",
    value: "subcontractor-shift",
  },
  {
    id: 3,
    name: "Breaks",
    value: "breaks",
  },
  {
    id: 4,
    name: "Public Holidays",
    value: "public-holidays",
  },
];

export const WasteSettingsTab = [
  {
    id: 1,
    name: "Documents",
    value: "Documents",
  },
  {
    id: 2,
    name: "Format",
    value: "Format",
  },
  {
    id: 3,
    name: "Archive",
    value: "Archive",
  },
];

export const summarySheetTabs = [
  {
    id: 1,
    name: "Drive",
    value: "Drive",
  },
  {
    id: 2,
    name: "Reports",
    value: "Reports",
  },
  {
    id: 3,
    name: "Logs",
    value: "Logs",
  },
];

export const WeightScaleTabs = [
  {
    id: 1,
    name: "Tickets",
    value: "Ticket",
  },
  {
    id: 2,
    name: "Issued Tickets",
    value: "IssuedTickets",
  },
  {
    id: 3,
    name: "Archive",
    value: "Archive",
  },
];

export const WeighBridgeTabs = [
  {
    id: 1,
    name: "Issued Tickets",
    value: "IssuedTickets",
  },
  {
    id: 2,
    name: "Drafts",
    value: "Drafts",
  },
];

export const ItemsTabs = [
  {
    id: 1,
    name: "Docket",
    value: "DOCKET",
  },
  {
    id: 2,
    name: "Estimation",
    value: "ESTIMATION",
  },
  {
    id: 3,
    name: "Group",
    value: "GROUP",
  },
  {
    id: 4,
    name: "Xero Items",
    value: "XERO",
  },
  {
    id: 5,
    name: "Deactivated Items",
    value: "DEACTIVATED",
  },
];

export const leadsSheetTab = [
  {
    id: 1,
    name: "Drive",
    value: "Drive",
  },
  // {
  //   id: 3,
  //   name: "Estimation",
  //   value: "Estimation",
  // },

  {
    id: 2,
    name: "Activity",
    value: "Activity",
  },
];

export const LeadsTab = [
  {
    id: 1,
    name: "All",
    value: "ALL",
  },
  {
    id: 2,
    name: "To Do",
    value: "ONGOING",
  },
  {
    id: 3,
    name: "Submitted",
    value: "SUBMITTED",
  },
  {
    id: 4,
    name: "Won",
    value: "WON",
  },
  {
    id: 5,
    name: "Unsuccessful",
    value: "ARCHIVE",
  },
];
export const ClaimsTabs = [
  {
    id: 1,
    name: "Ongoing",
    value: "ONGOING",
  },
  {
    id: 2,
    name: "Completed",
    value: "COMPLETED",
  },
  {
    id: 3,
    name: "Closed",
    value: "CLOSED",
  },
];

export const ClaimsSheetTabs = [
  {
    id: 1,
    name: "Approved",
    value: "APPROVED",
  },
  {
    id: 2,
    name: "Estimate",
    value: "ESTIMATE",
  },
  {
    id: 3,
    name: "Drafts",
    value: "DRAFT",
  },
  {
    id: 4,
    name: "Drive",
    value: "DRIVE",
  },
];

export const ContractClaimsTabs = [
  {
    id: 1,
    name: "Ready To Invoice",
    value: "READY_TO_INVOICE",
  },
  {
    id: 2,
    name: "Contract Invoice",
    value: "CONTRACT_INVOICE",
  },
];

export const DocketInvoiceTabs = [
  {
    id: 1,
    name: "Ready To Invoice",
    value: "READY_TO_INVOICE",
  },
  {
    id: 2,
    name: "Docket Invoice",
    value: "DOCKET_INVOICE",
  },
];

export const ContractInvoiceTabs = [
  {
    id: 1,
    name: "Ready To Invoice",
    value: "READY_TO_INVOICE",
  },
  {
    id: 2,
    name: "Contract Invoice",
    value: "CONTRACT_INVOICE",
  },
];

export const WareHouseTabs = [
  {
    id: 1,
    name: "Active",
    value: "ACTIVE",
  },
  {
    id: 2,
    name: "Archive",
    value: "ARCHIVE",
  },
];

export const WareHouseDetailTabs = [
  {
    id: 1,
    name: "Summary",
    value: "SUMMARY",
  },
  {
    id: 2,
    name: "Active Projects",
    value: "ACTIVE",
  },
  {
    id: 3,
    name: "Assign History",
    value: "ASSIGN_HISTORY",
  },
];

export const CalendarTabs = [
  {
    id: 1,
    name: "Events",
    value: "Event",
  },
  {
    id: 2,
    name: "Meetings",
    value: "Meeting",
  },
];

export const SupportTabs = [
  {
    id: 1,
    name: "Support Tickets List",
    value: "SupportTicketsList",
  },
  {
    id: 2,
    name: "Support Tickets Board",
    value: "SupportTicketsBoard",
  },
  {
    id: 3,
    name: "Team Contact",
    value: "TeamContact",
  },
  {
    id: 4,
    name: "Important Document",
    value: "ImportantDocument",
  },
];

export const productTabs = [
  {
    id: 1,
    name: "Active",
    value: "ACTIVE",
  },
  {
    id: 2,
    name: "Consumed",
    value: "CONSUMED",
  },
];

export const WorkDocketTab = [
  {
    id: 1,
    name: "Active",
    value: "ACTIVE",
  },
  {
    id: 2,
    name: "Voided",
    value: "VOIDED",
  },
];

export const assignToolsTabs = [
  {
    id: 1,
    name: "Assigned",
    value: "ASSIGNED",
  },
  {
    id: 2,
    name: "Awaiting",
    value: "AWAITING",
  },
  {
    id: 3,
    name: "On Site",
    value: "ONSITE",
  },
  {
    id: 4,
    name: "Return",
    value: "RETURNED",
  },
];

export const requestTabs = [
  {
    id: 1,
    name: "Return Request",
    value: "RETURN_REQUEST",
  },
  {
    id: 2,
    name: "Product Request",
    value: "PRODUCT_REQUEST",
  },
  {
    id: 3,
    name: "Transfer Request",
    value: "TRANSFER_REQUEST",
  },
  {
    id: 4,
    name: "Awaiting",
    value: "AWAITING",
  },
];
